import { Units } from "./convert";

// The locale system only ever vends these 8 display units; all call sites
// convert to a locale unit before calling decimalPlaces, so no other Units
// value should reach this function. Default to 2 to avoid a silent crash if
// a new unit is ever added without a matching case.
export const decimalPlaces = (u: Units): number => {
  switch (u) {
    case "in":
      return 2;
    case "ft":
      return 2;
    case "m":
      return 2;
    case "mm":
      return 0;
    case "in/h":
      return 2;
    case "mm/h":
      return 0;
    case "ft3/s":
      return 0;
    case "m3/s":
      return 0;
    default:
      return 2;
  }
};

export const formatUnit = (u: Units) => {
  switch (u) {
    case "ft3/s":
      return "cfs";
    case "m3/s":
      return "m³/s";
    default:
      return u;
  }
};
